const namespace = 'patients';

export const FETCH_PATIENTS = `${namespace}/FETCH_PATIENTS`;
export const SET_PATIENTS = `${namespace}/SET_PATIENTS`;
export const SET_PATIENTS_PAGE = `${namespace}/SET_PATIENTS_PAGE`;
export const SET_PATIENTS_SORT_ORDER = `${namespace}/SET_PATIENTS_SORT_ORDER`;
export const SET_PATIENTS_FILTER = `${namespace}/SET_PATIENTS_FILTER`;
export const SET_PATIENTS_BLANK_STATE = `${namespace}/SET_PATIENTS_BLANK_STATE`;
export const DOWNLOAD_PATIENTS_CSV = `${namespace}/DOWNLOAD_PATIENTS_CSV`;
